import request from '@/api/httpRequest2'

// 查询知识库列表
export function listKnowledgeBase(query) {
  return request({
    url: '/klgeek/knowledgeBase/list',
    method: 'get',
    params: query
  })
}

// 查询知识库详细
export function getKnowledgeBase(id) {
  return request({
    url: '/klgeek/knowledgeBase/' + id,
    method: 'get'
  })
}

// 查询知识库详情，包含目录和文档
export function getKnowledgeBaseDetail(id) {
  return request({
    url: '/klgeek/knowledgeBase/detail/' + id,
    method: 'get'
  })
}

// 新增知识库
export function addKnowledgeBase(data) {
  return request({
    url: '/klgeek/knowledgeBase',
    method: 'post',
    data: data
  })
}

// 修改知识库
export function updateKnowledgeBase(data) {
  return request({
    url: '/klgeek/knowledgeBase',
    method: 'put',
    data: data
  })
}

// 删除知识库
export function delKnowledgeBase(id) {
  return request({
    url: '/klgeek/knowledgeBase/' + id,
    method: 'delete'
  })
}

// 更新查看次数
export function updateViewCount(id) {
  return request({
    url: `/klgeek/knowledgeBase/view/${id}`,
    method: 'put'
  })
} 